import React from 'react';
import './FAQs.css';

const FAQs = () => {
  return (
    <div className="faqs-page">
      <div className="faqs-header">
        <div className="container">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about Thrive Holdings Limited</p>
        </div>
      </div>
      
      <div className="container faqs-content my-5">
        <div className="faq-item">
          <h3>What is Thrive Holdings Limited?</h3>
          <p>Thrive Holdings Limited is a company dedicated to . We are committed to delivering excellence and innovation in all our endeavors.</p>
        </div>
        <div className="faq-item">
          <h3>How can I contact you?</h3>
          <p>You can contact us through our <a href="/contact">contact page</a> or by emailing <a href="mailto:infoinsurance@thrivenig.com">infoinsurance@thrivenig.com</a>. Our team is ready to assist you with any inquiries.</p>
        </div>
        <div className="faq-item">
          <h3>What services do you offer?</h3>
          <p>We offer a range of services. Visit our <a href="/what-we-do">services page</a> for detailed information.</p>
        </div>
        <div className="faq-item">
          <h3>How do I apply for a job?</h3>
          <p>Visit our <a href="/career">careers page</a> for current openings and application instructions. We welcome talented individuals to join our team.</p>
        </div>
        <div className="faq-item">
          <h3>Where are you located?</h3>
          <p>You can find our office locations and contact information on our <a href="/contact">contact page</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default FAQs;